<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">EEG · Bundesnetzagentur</p>
      <h2 class="presentation-page__title">EEG-Einspeisetarife (gültig bis 31.07.2026)</h2>
      <p class="presentation-page__text">
        Anzulegende Werte für PV-Aufdachanlagen — Marktprämie nach Anlagengröße gestaffelt.
      </p>
      <table class="presentation-page__data-table">
        <thead>
          <tr>
            <th>Anlagengröße (kWp)</th>
            <th>Eigenverbrauch (ct/kWh)</th>
            <th>Volleinspeisung (ct/kWh)</th>
            <th>Bemerkung</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="row.size"
            :class="{ 'presentation-page__data-table__row--highlight': row.highlight }"
          >
            <td>{{ row.size }}</td>
            <td class="presentation-page__data-table__cell--value">{{ row.selfConsumption }}</td>
            <td class="presentation-page__data-table__cell--value">{{ row.fullFeedIn }}</td>
            <td>{{ row.note }}</td>
          </tr>
        </tbody>
      </table>
      <p class="presentation-page__data-table-source">
        Quelle: Bundesnetzagentur · Anzulegende Werte für Solaranlagen · Inbetriebnahmen 1.2 –
        31.7.2026
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage36',
  components: { PrintPageLandscape, PresentationPage },
  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  data() {
    return {
      rows: [
        {
          size: 'bis 10 kWp',
          selfConsumption: '8,03',
          fullFeedIn: '12,73',
          note: 'Privatkundensegment',
        },
        {
          size: '10 – 40 kWp',
          selfConsumption: '6,95',
          fullFeedIn: '10,67',
          note: 'Gewerbe klein',
        },
        {
          size: '40 – 100 kWp',
          selfConsumption: '5,68',
          fullFeedIn: '10,67',
          note: 'Gewerbe mittel',
        },
        {
          size: '100 – 300 kWp',
          selfConsumption: '5,15',
          fullFeedIn: '9,578',
          note: 'Gewerbe groß',
          highlight: false,
        },
        {
          size: '300 – 1.000 kWp',
          selfConsumption: '4,80',
          fullFeedIn: '8,40',
          note: 'Gewerbe sehr groß',
        },
      ],
    };
  },
};
</script>
